import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getProjectImgAndShareIcon } from 'utils/projectHelpers';
import { useSelector } from 'react-redux';
import { useAlert } from 'react-alert';
import { getError, getUserLocale } from 'utils/appHelpers';
import { getProjects, toggleProjectFromLikiee } from 'app/routes/Dashboard/actions/projects';
import ProjectModal from 'app/routes/Dashboard/routes/Home/components/ProjectModal';
import ManageModal from '../modals/ManageModal';
import CheckBox from '../CheckBox';
import { addLikieesToProjects } from 'graphql/projects/mutations';
import { API, graphqlOperation } from 'aws-amplify';
import { createProduct } from 'app/routes/Dashboard/actions/products';
import Loading from '../Loading';

const SaveToProjectModal = ({ onClose, initialProjectIDs, productID, productIDS, onSuccess, title, saveToLink }) => {
  const alert = useAlert();
  const { t } = useTranslation();
  const projectsObj = useSelector(state => state.projects);
  const projects = Object.values(projectsObj || {});
  const [fetching, setFetching] = useState(false);
  const [projectIDs, setProjectIds] = useState(initialProjectIDs || []);
  const [showProjectCreation, setShowProjectCreation] = useState(false);

  const onFormChange = item => {
    const tempData = [...projectIDs];
    if (tempData.includes(item)) {
      tempData.splice(tempData.indexOf(item), 1);
    } else {
      tempData.push(item);
    }
    setProjectIds(tempData);
  };

  const onSubmitProduct = async id => {
    try {
      setFetching(true);
      await toggleProjectFromLikiee(id || productID, projectIDs);
      setFetching(false);
      alert.success(t('msg_success_product_project_updated'));
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      alert.error(getError(err));
      setFetching(false);
    }
  };

  const onSubmitProducts = async () => {
    try {
      setFetching(true);
      const body = { projectIDs, likieeIDs: productIDS };
      await API.graphql(graphqlOperation(addLikieesToProjects, body));
      setFetching(false);
      alert.success(t('msg_success_product_project_updated'));
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      alert.error(getError(err));
      setFetching(false);
    }
  };

  const saveProductLink = async () => {
    try {
      setFetching(true);
      const locale = getUserLocale();
      const product = await createProduct({ url: saveToLink, locale });
      await onSubmitProduct(product.id);
    } catch (err) {
      alert.error(getError(err));
      setFetching(false);
    }
  };

  const onCloseProjectCreation = () => {
    setShowProjectCreation(false);
  };

  useEffect(() => {
    if (!projectsObj) getProjects();
  }, []);

  if (showProjectCreation) {
    return <ProjectModal onClose={onCloseProjectCreation} />;
  }

  return (
    <ManageModal
      title={title || saveToLink ? t('title_save_to') : t('save_to_projects_title')}
      sumbitButton={t('btn_save')}
      onCloseModal={onClose}
      onSubmit={saveToLink ? saveProductLink : productIDS ? onSubmitProducts : onSubmitProduct}
      className='alert-modal'
      isButtonDisabled={fetching}
    >
      <div className='row pb-5'>
        <div className='col-12'>
          <div className='d-flex align-items-center justify-content-between mb-8'>
            <p className='text-dark fw-500 mb-0'>{t('your_projects')}</p>
            <button className='btn p-0 text-primary text-underline' onClick={() => setShowProjectCreation(true)}>
              {t('btn_create_new_project')}
            </button>
          </div>
          <div className='scroll-y-content max-h-300'>
            {projects.map((item, index) => {
              const { Icon, image } = getProjectImgAndShareIcon(item);
              return (
                <CheckBox
                  key={index}
                  className='mb-10'
                  label={
                    <div className='d-flex align-items-center cursor-pointer'>
                      <div className='project-img-type mr-8 position-relative'>
                        <img width='54' height='54' src={image} alt='project' />
                        <div className='action-btn right-bottom-corner is-small text-center'>
                          <Icon width='18' height='18' />
                        </div>
                      </div>
                      {item.name}
                    </div>
                  }
                  id={`check${item.id}`}
                  name={`check${item.id}`}
                  checked={projectIDs.includes(item.id)}
                  onChange={onFormChange.bind(null, item.id)}
                />
              );
            })}
            {!projectsObj && <Loading />}
          </div>
        </div>
      </div>
    </ManageModal>
  );
};

export default SaveToProjectModal;
